var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,24a3.822,3.822,0,0,1-2.059-1.2,7.437,7.437,0,0,0-1.878-1.3,7.763,7.763,0,0,0-2.316-.435,3.819,3.819,0,0,1-2.233-.586,3.8,3.8,0,0,1-.584-2.213l0-.019a7.725,7.725,0,0,0-.434-2.317A7.4,7.4,0,0,0,1.2,14.068L1.2,14.061A3.826,3.826,0,0,1,0,12,3.818,3.818,0,0,1,1.2,9.939l.009-.011A7.4,7.4,0,0,0,2.495,8.063a7.719,7.719,0,0,0,.434-2.316V5.74a3.816,3.816,0,0,1,.585-2.226A3.8,3.8,0,0,1,5.728,2.93l.019,0a7.719,7.719,0,0,0,2.316-.434A7.4,7.4,0,0,0,9.928,1.207L9.939,1.2A3.818,3.818,0,0,1,12,0a3.826,3.826,0,0,1,2.062,1.2l.006.005a7.4,7.4,0,0,0,1.868,1.291,7.725,7.725,0,0,0,2.316.434h.007a3.814,3.814,0,0,1,2.225.585A3.816,3.816,0,0,1,21.07,5.74v.007a7.763,7.763,0,0,0,.435,2.316,7.422,7.422,0,0,0,1.3,1.875A3.83,3.83,0,0,1,24,12a3.821,3.821,0,0,1-1.194,2.057l0,0a7.393,7.393,0,0,0-1.3,1.875,7.77,7.77,0,0,0-.435,2.317,3.817,3.817,0,0,1-.586,2.232,3.814,3.814,0,0,1-2.225.585h-.007a7.769,7.769,0,0,0-2.317.435,7.393,7.393,0,0,0-1.875,1.3l0,0A3.821,3.821,0,0,1,12,24Zm6.2-13A7.208,7.208,0,0,1,11,18.2V20a9.01,9.01,0,0,0,9-9ZM13,4a9.01,9.01,0,0,0-9,9H5.8A7.209,7.209,0,0,1,13,5.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrand);
export default __webpack_public_path__ + "static/media/icon-brand.b8d7578e4169b2ec37afa6af1ce83647.svg";
export { ForwardRef as ReactComponent };